import { createStore } from "owa-satcheljs";
import type { SuggestedUnsubscribeStoreMap, SuggestedUnsubscribeStore, } from "./schema/SuggestedUnsubscribeStore";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";

function defaultStore(): SuggestedUnsubscribeStore {
    return {
        lastFetch: 0,
        suggestedUnsubscribeItems: [],
    };
}

const getSuggestedUnsubscribeStoreMap = createStore<SuggestedUnsubscribeStoreMap>("suggestedUnsubscribeStore", {
    entries: new Map(),
});

export function getSuggestedUnsubscribeStore(mailboxInfo: MailboxInfo): SuggestedUnsubscribeStore {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    let store = getSuggestedUnsubscribeStoreMap().entries.get(accountKey);
    if (!store) {
        store = defaultStore();
        getSuggestedUnsubscribeStoreMap().entries.set(accountKey, store);
    }
    return store;
}
